import { atom } from "recoil";
import { recoilPersist } from "../../config";
import AsyncStorage from "@react-native-async-storage/async-storage";
const { persistAtom } = recoilPersist({
  key: "recoil-persist",
  // storage: AsyncStorage,
  storage: localStorage,
});
export const tokenState = atom({
  key: "token",
  default: {},
  effects_UNSTABLE: [persistAtom],
});

export const userState = atom({
  key: "user",
  default: {},
  effects_UNSTABLE: [persistAtom],
});

export const winds = atom({
  key: "winds",
  default: {
    height: window.innerHeight,
    width: window.innerWidth,
  },
  effects_UNSTABLE: [persistAtom],
});
